// src/InfoBlock.js
import React from "react";
import "./InfoBlock.css";

const InfoBlock = ({ title, value, icon, disabled }) => {
  return (
    <div className={`info-block ${disabled ? "info-block-disabled" : ""}`}>
      <div className="info-title">{title}</div>
      <div className="info-value">
        {icon && (
          <div className="info-icon">
            <img src={icon} alt={title} />
          </div>
        )}
        <div className="info-value-value">{disabled ? "N/A" : value}</div>
      </div>
    </div>
  );
};

InfoBlock.defaultProps = {};

export default InfoBlock;



// WEBPACK FOOTER //
// ./src/components/Dashboard/ReVAMP_Dashboard/ReVAMPDashboardComponent/InfoBlock.jsx